<template>
    <div class="">
        <div id="c1"></div>

<!--        <dataSets/>-->
        <p class="list">{{name}}欢迎您登录响贝管理系统。</p>

        <p class="list">{{getCurrentDate(2)}} </p>

<!--        <p class="list">ip ： {{home.ip}} </p>-->
<!--        <img src="../../assets/home.png" alt="" class="homeimg">-->
<!--        <p v-for="item in arr">{{item}}</p>-->
<!--        <span @click="chang">aaa</span>-->
    </div>
</template>

<script>

    export default {
        name: "index",
        created () {
            this.$store.state.adminleftnavnum="/home"; //设置左侧导航2-2 active
        },
        data(){
            return{
                // home:JSON.parse(window.sessionStorage.getItem('homeData')),
                arr:["a","b","c"],
             name: window.sessionStorage.getItem('userName') ,
            }
        },
        methods:{
              getCurrentDate(format) {
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth();//得到月份
        var date = now.getDate();//得到日期
        var day = now.getDay();//得到周几
        var hour = now.getHours();//得到小时
        var minu = now.getMinutes();//得到分钟
        var sec = now.getSeconds();//得到秒
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        if (hour < 10) hour = "0" + hour;
        if (minu < 10) minu = "0" + minu;
        if (sec < 10) sec = "0" + sec;
        var time = "";
        //精确到天
        if(format==1){
            time = year + "-" + month + "-" + date;
        }
        //精确到分
        else if(format==2){
            time = year + "-" + month + "-" + date+ " " + hour + ":" + minu + ":" + sec;
        }
        return time;
    },
            chang(){
                this.arr[0]="123"
                this.$nextTick(() => {

                })
                this.$set(this.arr,0,"dateArr")
            }
        }

    }
</script>

<style scoped>
/*.list{margin-bottom: 15px;display: inline-block;margin-right: 10px}*/
.list{margin-bottom: 15px; }
</style>
